import { type FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

export const WillSafeDepositScreen: FC<FlowCustomComponentProps> = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          You need court permission to open the bank box
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          Banks automatically seal safety deposit boxes when someone passes away. You must get a
          court order before the bank will let you look inside for the original will.
        </p>
      </div>

      <div className="flex flex-col rounded-lg border border-primary overflow-clip">
        <div className="flex flex-col gap-2 bg-white border-b border-primary p-6">
          <p className="text-sm font-semibold">Request permission from the court</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            We will generate a quick request form for the court asking the judge to let you
            examine the bank box for the original will.
          </p>
        </div>
        <div className="flex flex-col gap-2 bg-white border-b border-primary p-6">
          <p className="text-sm font-semibold">Open the box with a bank officer</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            Once the judge approves your request, you'll take the court order to the bank. A bank
            employee will open the box with you and send the original will directly to the court
            clerk.
          </p>
        </div>
        <div className="flex flex-col gap-2 bg-white p-6">
          <p className="text-sm font-semibold">Return here to finish your setup</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            After the court receives the original will from the bank, you can come right back here
            to complete the rest of your estate forms.
          </p>
        </div>
      </div>
    </div>
  );
};
